import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page71() {
  useEffect(() => {
    document.title = "Маяк — Страница 70"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page69" />
        <ForwardLink href="/page71" />
      </div>

      <p style={{ textAlign: "right" }}>70.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        <i>Моя любовница, она спит,<br/>
        Моя любовница тепла, и ее сердце<br/>
        мягко,<br/>
        Я бы отдал весь мир, лишь бы<br/>
        разделить с ней постель,</i>
      </p>
      <p>ПЕСНЯ изменила настроение МОЛОДОГО, он смягчился...</p>
      <p>Робко и тихо он присоединяется к последней строчке...</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        (поет вполголоса)<br/>
        <i>В понедельник утром.</i>
      </p>
      <p>Гремит гром...</p>
      <p>Они прижимаются друг к другу...</p>
      <p>Это очень напряженная ситуация...</p>
      <p>Кажется, они могут поцеловаться...</p>
      <p><i>Нет, это просто безумие.</i></p>
      <p>Пауза.</p>
      <p>
        МОЛОДОЙ отталкивает СТАРИКА. Он поднимает кулаки как старый<br/>
        боксер.
      </p>
      <p>СТАРИК тоже.</p>
      <p>
        Они по очереди бьют друг друга в шуточном бою. СТАРИК продолжает
        бить МОЛОДОГО, так как МОЛОДОЙ более пьян.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Ты ублюдок.
      </p>
      <p>ШУТОЧНЫЙ БОЙ ОБОСТРЯЕТСЯ... УДАРЫ СТАНОВЯТСЯ СИЛЬНЕЕ...</p>
      <p>ЗАТЕМ...</p>
      <p>
        МОЛОДОЙ хватает СТАРИКА и швыряет его в заплесневелый шкаф! СТАРИК<br/>
        хихикает. ОНИ опрокидывают весь шкаф с чашками и посудой.
      </p>
      <p>
        СТАРИК бросает тарелки в МОЛОДОГО, почти попадая в него... посуда<br/>
        разбивается о стены.
      </p>
      <p>
        Они начинают швырять друг в друга остатки рыбных костей и картофельных шкурок<br/>
        из своих тарелок... смеясь.
      </p>
      <p>Они истерически пьяны. Безумны.</p>
      <p>МОЛОДОЙ бросает мыльницу... Она разлетается</p>
      <p style={{ textAlign: "right" }}>70.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page69" />
        <ForwardLink href="/page71" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710633681/the-lighthouse-script/crpcyf6xmpqgacwu8mmp.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page71;
